module.exports = __webpack_public_path__ + "img/foot_WeChat.f997c1f8.jpg";